import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { AcceptedHtmlElementContent, appendHTMLElementContent } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { WebPageComponent } from "../pageComponent";

/**
 * Basic Page that can be used from javascript to provide static content
 * 
 * Even if we don't plan to use this page from HTML, we need to decorate it as a CustomElement because
 * you can't call the HtmlElement contructor [super()] if you have not registered the custom element in the DOM
 */
@CustomElement({
    name: "content-page"
})
export class ContentPage extends WebPageComponent {

    /**
     * @param _params 
     * @param _params.html html content
     * @param _params.style css style
     * @param _params.attachShadowParams attachShadow params if component needs to be attached to shadow DOM
     */
    constructor(protected _params: { html?: AcceptedHtmlElementContent, style?: string, attachShadowParams?: ShadowRootInit }) {
        super();
    }

    /**
     * Append the html template and style
     */
    public override init(): void {
        const div = document.createElement("div");
        if (this._params.style) {
            appendHTMLElementContent(div, `<style>${this._params.style}</style>`);
        }
        if (this._params.html) {
            appendHTMLElementContent(div, this._params.html);
        }

        if (this._params.attachShadowParams) {
            this.attachShadow(this._params.attachShadowParams).appendChild(div);
        } else {
            this.appendChild(div);
        }
    }

}